(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dynofitauto-brand-intro-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dynofit-brand-carousel')) {
    class DynofitBrandCarousel extends HTMLElement {
      #abortController = null;
      #timer = null;
      #index = 0;
      #startX = 0;
      #deltaX = 0;
      #isDragging = false;
      #activePointerId = null;
      #slideStep = 65;

      connectedCallback() {
        this.#abortController?.abort();
        this.#abortController = new AbortController();

        this.track = this.querySelector('[data-brand-track]');
        this.slides = [...this.querySelectorAll('[data-brand-slide]')];
        this.previousButton = this.querySelector('[data-brand-previous]');
        this.nextButton = this.querySelector('[data-brand-next]');
        this.dotsContainer = this.querySelector('[data-brand-dots]');
        this.dots = [];

        if (!this.track || this.slides.length === 0) return;

        this.#index = Math.min(this.#index, this.slides.length - 1);
        this.autoplay = this.dataset.autoplay === 'true';
        this.interval = Math.max(3000, Number.parseInt(this.dataset.interval || '5000', 10));
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.#createDots();
        this.#bindEvents();
        this.#update(false);
        this.#startAutoplay();
      }

      disconnectedCallback() {
        this.#stopAutoplay();
        this.#abortController?.abort();
      }

      #bindEvents() {
        const signal = this.#abortController.signal;

        this.previousButton?.addEventListener('click', () => this.#goTo(this.#index - 1), { signal });
        this.nextButton?.addEventListener('click', () => this.#goTo(this.#index + 1), { signal });

        this.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.#goTo(this.#index - 1);
          }

          if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.#goTo(this.#index + 1);
          }
        }, { signal });

        this.addEventListener('pointerdown', (event) => this.#startDrag(event), { signal });
        this.addEventListener('pointermove', (event) => this.#moveDrag(event), { signal });
        this.addEventListener('pointerup', (event) => this.#endDrag(event), { signal });
        this.addEventListener('pointercancel', (event) => this.#cancelDrag(event), { signal });
        this.addEventListener('lostpointercapture', (event) => this.#cancelDrag(event), { signal });

        this.addEventListener('mouseenter', () => this.#stopAutoplay(), { signal });
        this.addEventListener('mouseleave', () => this.#startAutoplay(), { signal });
        this.addEventListener('focusin', () => this.#stopAutoplay(), { signal });
        this.addEventListener('focusout', (event) => {
          if (!this.contains(event.relatedTarget)) this.#startAutoplay();
        }, { signal });

        this.addEventListener('shopify:block:select', (event) => {
          const selectedSlide = event.target.closest('[data-brand-slide]');
          const selectedIndex = this.slides.indexOf(selectedSlide);
          if (selectedIndex >= 0) this.#goTo(selectedIndex, false);
        }, { signal });

        document.addEventListener('visibilitychange', () => {
          if (document.hidden) this.#stopAutoplay();
          else this.#startAutoplay();
        }, { signal });
      }

      #createDots() {
        if (!this.dotsContainer) return;

        this.dotsContainer.replaceChildren();

        for (const [index] of this.slides.entries()) {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'dynofit-brand-slider__dot';
          dot.setAttribute('aria-label', `Load slide ${index + 1}`);
          dot.addEventListener('click', () => this.#goTo(index), {
            signal: this.#abortController.signal
          });
          this.dotsContainer.appendChild(dot);
          this.dots.push(dot);
        }
      }

      #goTo(index, restartAutoplay = true) {
        this.#index = (index + this.slides.length) % this.slides.length;
        this.#update();

        if (restartAutoplay) {
          this.#stopAutoplay();
          this.#startAutoplay();
        }
      }

      #update(animate = true) {
        this.track.classList.toggle('is-dragging', !animate);
        this.track.style.transform = `translate3d(${-this.#index * this.#slideStep}%, 0, 0)`;

        for (const [index, slide] of this.slides.entries()) {
          const isActive = index === this.#index;
          slide.classList.toggle('is-active', isActive);
          slide.setAttribute('aria-hidden', String(!isActive));
          slide.inert = !isActive;
        }

        for (const [index, dot] of this.dots.entries()) {
          const isActive = index === this.#index;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-current', isActive ? 'true' : 'false');
        }

        if (!animate) {
          requestAnimationFrame(() => this.track.classList.remove('is-dragging'));
        }
      }

      #startDrag(event) {
        if (
          this.slides.length < 2 ||
          event.button !== 0 ||
          event.isPrimary === false ||
          event.target.closest('a, button, input, select, textarea, label')
        ) return;

        this.#isDragging = true;
        this.#activePointerId = event.pointerId;
        this.#startX = event.clientX;
        this.#deltaX = 0;
        this.track.classList.add('is-dragging');
        this.setPointerCapture(event.pointerId);
        this.#stopAutoplay();
      }

      #moveDrag(event) {
        if (!this.#isDragging || event.pointerId !== this.#activePointerId) return;

        this.#deltaX = event.clientX - this.#startX;
        const width = this.clientWidth || 1;
        const progress = (this.#deltaX / width) * 100;
        this.track.style.transform = `translate3d(${(-this.#index * this.#slideStep) + progress}%, 0, 0)`;

        if (Math.abs(this.#deltaX) > 8 && event.cancelable) event.preventDefault();
      }

      #endDrag(event) {
        if (!this.#isDragging || event.pointerId !== this.#activePointerId) return;

        this.#isDragging = false;
        this.track.classList.remove('is-dragging');

        if (this.hasPointerCapture(event.pointerId)) {
          this.releasePointerCapture(event.pointerId);
        }

        const threshold = Math.min(80, Math.max(30, this.clientWidth * 0.12));

        if (Math.abs(this.#deltaX) > threshold) {
          this.#goTo(this.#index + (this.#deltaX < 0 ? 1 : -1));
        } else {
          this.#update();
          this.#startAutoplay();
        }

        this.#deltaX = 0;
        this.#activePointerId = null;
      }

      #cancelDrag(event) {
        if (!this.#isDragging || event.pointerId !== this.#activePointerId) return;

        this.#isDragging = false;
        this.#activePointerId = null;
        this.#deltaX = 0;
        this.track.classList.remove('is-dragging');
        this.#update();
        this.#startAutoplay();
      }

      #startAutoplay() {
        if (
          !this.autoplay ||
          this.reducedMotion ||
          document.hidden ||
          this.slides.length < 2 ||
          this.#timer
        ) return;

        this.#timer = window.setInterval(() => this.#goTo(this.#index + 1, false), this.interval);
      }

      #stopAutoplay() {
        if (!this.#timer) return;
        window.clearInterval(this.#timer);
        this.#timer = null;
      }
    }

    customElements.define('dynofit-brand-carousel', DynofitBrandCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dynofitauto-responsive-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dynofitauto-carousel')) {
    class DynofitautoCarousel extends HTMLElement {
      #abortController = null;
      #intersectionObserver = null;
      #timer = null;
      #index = 0;
      #isDragging = false;
      #startX = 0;
      #deltaX = 0;
      #isVisible = false;

      connectedCallback() {
        this.#abortController?.abort();
        this.#abortController = new AbortController();

        this.track = this.querySelector('[data-carousel-track]');
        this.viewport = this.querySelector('[data-carousel-viewport]');
        this.slides = [...this.querySelectorAll('[data-carousel-slide]')];
        this.previousButton = this.querySelector('[data-carousel-previous]');
        this.nextButton = this.querySelector('[data-carousel-next]');
        this.dotsContainer = this.querySelector('[data-carousel-dots]');
        this.dots = [];

        if (!this.track || !this.viewport || this.slides.length === 0) return;

        this.autoplay = this.dataset.autoplay === 'true';
        this.pauseOnHover = this.dataset.pauseOnHover === 'true';
        this.interval = Math.max(2000, Number.parseInt(this.dataset.interval || '4000', 10));
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.#createDots();
        this.#bindEvents();
        this.#observeVisibility();
        this.#update(false);
      }

      disconnectedCallback() {
        this.#stopAutoplay();
        this.#intersectionObserver?.disconnect();
        this.#abortController?.abort();
      }

      #bindEvents() {
        const signal = this.#abortController.signal;

        this.nextButton?.addEventListener('click', () => this.#goTo(this.#index + 1), { signal });
        this.previousButton?.addEventListener('click', () => this.#goTo(this.#index - 1), { signal });

        this.viewport.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.#goTo(this.#index + 1);
          }

          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.#goTo(this.#index - 1);
          }
        }, { signal });

        this.viewport.addEventListener('pointerdown', (event) => this.#startDrag(event), { signal });
        this.viewport.addEventListener('pointermove', (event) => this.#moveDrag(event), { signal });
        this.viewport.addEventListener('pointerup', (event) => this.#endDrag(event), { signal });
        this.viewport.addEventListener('pointercancel', (event) => this.#endDrag(event), { signal });

        if (this.pauseOnHover) {
          this.addEventListener('mouseenter', () => this.#stopAutoplay(), { signal });
          this.addEventListener('mouseleave', () => this.#startAutoplay(), { signal });
          this.addEventListener('focusin', () => this.#stopAutoplay(), { signal });
          this.addEventListener('focusout', (event) => {
            if (!this.contains(event.relatedTarget)) this.#startAutoplay();
          }, { signal });
        }

        document.addEventListener('visibilitychange', () => {
          if (document.hidden) {
            this.#stopAutoplay();
          } else {
            this.#startAutoplay();
          }
        }, { signal });

        this.addEventListener('shopify:block:select', (event) => {
          const selectedSlide = event.target.closest('[data-carousel-slide]');
          const selectedIndex = this.slides.indexOf(selectedSlide);
          if (selectedIndex >= 0) this.#goTo(selectedIndex, false);
        }, { signal });
      }

      #createDots() {
        if (!this.dotsContainer) return;

        this.dotsContainer.replaceChildren();

        for (const [index] of this.slides.entries()) {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'dynofitauto-carousel__dot';
          button.setAttribute('aria-label', `${this.#loadSlideLabel()} ${index + 1}`);
          button.addEventListener('click', () => this.#goTo(index), {
            signal: this.#abortController.signal
          });
          this.dotsContainer.appendChild(button);
          this.dots.push(button);
        }
      }

      #loadSlideLabel() {
        return this.dataset.loadSlideLabel || 'Load slide';
      }

      #observeVisibility() {
        this.#intersectionObserver = new IntersectionObserver((entries) => {
          for (const entry of entries) {
            this.#isVisible = entry.isIntersecting;
            if (this.#isVisible) {
              this.#startAutoplay();
            } else {
              this.#stopAutoplay();
            }
          }
        }, { threshold: 0.2 });

        this.#intersectionObserver.observe(this);
      }

      #goTo(index, restartAutoplay = true) {
        this.#index = (index + this.slides.length) % this.slides.length;
        this.#update();

        if (restartAutoplay) this.#restartAutoplay();
      }

      #update(animate = true) {
        this.track.classList.toggle('is-dragging', !animate);
        this.track.style.transform = `translateX(${-this.#index * 100}%)`;

        for (const [index, slide] of this.slides.entries()) {
          const isActive = index === this.#index;
          slide.setAttribute('aria-hidden', String(!isActive));
          slide.inert = !isActive;
        }

        for (const [index, dot] of this.dots.entries()) {
          const isActive = index === this.#index;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-current', isActive ? 'true' : 'false');
        }

        if (!animate) requestAnimationFrame(() => this.track.classList.remove('is-dragging'));
      }

      #startDrag(event) {
        if (this.slides.length < 2 || event.button !== 0) return;

        this.#isDragging = true;
        this.#startX = event.clientX;
        this.#deltaX = 0;
        this.track.classList.add('is-dragging');
        this.viewport.setPointerCapture(event.pointerId);
        this.#stopAutoplay();
      }

      #moveDrag(event) {
        if (!this.#isDragging) return;

        this.#deltaX = event.clientX - this.#startX;
        const viewportWidth = this.viewport.clientWidth || 1;
        const progress = (this.#deltaX / viewportWidth) * 100;
        this.track.style.transform = `translateX(${(-this.#index * 100) + progress}%)`;
      }

      #endDrag(event) {
        if (!this.#isDragging) return;

        this.#isDragging = false;
        this.track.classList.remove('is-dragging');

        const viewportWidth = this.viewport.clientWidth || 1;
        const threshold = Math.min(80, Math.max(30, viewportWidth * 0.12));

        if (Math.abs(this.#deltaX) > threshold) {
          this.#goTo(this.#index + (this.#deltaX < 0 ? 1 : -1));
        } else {
          this.#update();
          this.#startAutoplay();
        }

        this.#deltaX = 0;

        if (this.viewport.hasPointerCapture(event.pointerId)) {
          this.viewport.releasePointerCapture(event.pointerId);
        }
      }

      #startAutoplay() {
        if (
          !this.autoplay ||
          this.reducedMotion ||
          !this.#isVisible ||
          document.hidden ||
          this.slides.length < 2 ||
          this.#timer
        ) return;

        this.#timer = window.setInterval(() => this.#goTo(this.#index + 1, false), this.interval);
      }

      #stopAutoplay() {
        if (!this.#timer) return;
        window.clearInterval(this.#timer);
        this.#timer = null;
      }

      #restartAutoplay() {
        this.#stopAutoplay();
        this.#startAutoplay();
      }
    }

    customElements.define('dynofitauto-carousel', DynofitautoCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('custom-accordion').then(() => {
    class FooterAccordion extends CustomAccordion {
      constructor() {
        super();
        this.wasDesktop = window.matchMedia('(min-width: 750px)').matches;
        this.updateOpenState();
        window.addEventListener('resizeend', this.updateOpenState.bind(this));
      }

      updateOpenState() {
        if (window.matchMedia('(min-width: 750px)').matches) {
          this.detailsElem.open = true;
          this.summaryElem.setAttribute('tabindex', '-1');
          this.summaryElem.classList.add('pointer-events-none');
          this.wasDesktop = true;
        } else if (this.wasDesktop) {
          this.detailsElem.open = false;
          this.summaryElem.removeAttribute('tabindex');
          this.summaryElem.classList.remove('pointer-events-none');
          this.wasDesktop = false;
        }
      }
    }

    customElements.define('footer-accordion', FooterAccordion);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.headerBounds = {};

      this.setHeaderHeight();
      this.setHeaderHeightLive();

      window.addEventListener('resizeend', this.setHeaderHeight.bind(this));
      window.addEventListener('resizeend', this.setHeaderHeightLive.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.lastScrollTrigger = 0;
      this.scrollThreshold = 50;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.searchButton = this.querySelector('.header__icon--search');
      if (this.searchButton) {
        this.searchButton.addEventListener('click', this.searchButtonClick.bind(this));
      }

      this.createObserver();
    }

    searchButtonClick() {
      this.preventHide = true;
      requestAnimationFrame(() => { this.preventHide = false; });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    setHeaderHeightLive(event, zero) {
      document.documentElement.style.setProperty('--header-height-live', `${zero ? 0 : this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      requestAnimationFrame(() => {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

        // Only trigger actions if the scroll has changed by at least the threshold value
        if (Math.abs(scrollTop - this.lastScrollTrigger) < this.scrollThreshold) return;

        const scrollDifference = scrollTop - this.currentScrollTop;
        // Handle scrolling classes based on 50px sensitivity
        if (scrollDifference > 50 && this.pauseScrollListen !== true) {
          // Scrolling down
          this.pauseScrollListen = true;
          this.header.classList.add('scrolling-down');
          this.header.classList.remove('scrolling-up');
          setTimeout(() => { this.pauseScrollListen = false; }, 320);
        } else if (scrollDifference < -50 && this.pauseScrollListen !== true) {
          // Scrolling up
          this.pauseScrollListen = true;
          this.header.classList.add('scrolling-up');
          this.header.classList.remove('scrolling-down');
          setTimeout(() => { this.pauseScrollListen = false; }, 320);
        }

        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          // Main logic for scrolling down
          this.header.classList.add('scrolled-past-header');
          if (this.preventHide) return;
          requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          // Main logic for scrolling up
          this.header.classList.add('scrolled-past-header');
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          } else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        } else if (scrollTop <= this.headerBounds.top) {
          // Reset at the top
          this.header.classList.remove('scrolled-past-header');
          this.header.classList.remove('scrolling-down');
          this.header.classList.remove('scrolling-up');
          requestAnimationFrame(this.reset.bind(this));
        }

        this.currentScrollTop = scrollTop;
        this.lastScrollTrigger = scrollTop; // Update the last scroll position that triggered an action
      });
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
      this.setHeaderHeightLive(null, true);
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      this.setHeaderHeightLive();
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close?.(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
